import { WEBSITE_MODE } from '@sitegen/common/constants';

export const isCSSVariableSet = (variable: string): boolean => {
    const value: string = getComputedStyle(document.body).getPropertyValue(variable);
    /* There can be extra spaces in variable value */
    return !!value && !value.includes('none');
};

export const getModeClass = (className: string, shouldInheritStyles?: boolean) =>
    `${className}${shouldInheritStyles ? '-embedded' : ''}`;

export const isEmbedded = (mode: WEBSITE_MODE = WEBSITE_MODE.STANDALONE) => (mode === WEBSITE_MODE.EMBEDDED);
